module.exports = __webpack_public_path__ + "static/media/broadband.e70b8bd9.png";